module.exports = __webpack_public_path__ + "static/media/kids_reading_blue.a84d330e.png";